<div class="emds">
    <div class="modal-default"
         id="{{Id}}">
      <div class="modal-header">
        <span *ngIf="activeAttachmentInfo?.Name">{{activeAttachmentInfo?.Name}}</span>
        <div id="{{Id}}-close"
             class="emds-close"
             (click)="dismissModal()">
        </div>
      </div>
      <div class="modal-body">
        <div *ngIf="showChips">
          <div class="row">
            <div class="col-md-12 col-xs-12 form-group">
              <span *ngFor="let attachmentInfo of attachmentInfos">
                <a class="chip"
                   (click)="setActiveAttachment(attachmentInfo)">{{attachmentInfo.Name}}</a>
              </span>
            </div>
          </div>
          <hr class="big-blue">
        </div>
        <div *ngIf="isAttachment">
            <ap-enhanced-document-viewer
                [documentId]="documentId"
                [getAttachmentHandler]="getAttachmentHandlerRef"
                [documentDownload]="getDownloadDocumentRef"
                [enableDownload]="true"
                [downloadFileName]="activeAttachmentInfo?.FileName"
                [disableInlinePdf]="false"
                [disableFullscreen]="true"
                [documentLoad]="loadAttachmentRef"
            ></ap-enhanced-document-viewer>
        </div>
        <div *ngIf="!isAttachment"> <!-- class="col-xs-12 col-xs-flush" -->
          <ap-enhanced-document-viewer
              [documentId]="documentId"
              [documentDownload]="getDownloadDocumentRef"
              [enableDownload]="true"
              [downloadFileName]="documentId"
              [disableInlinePdf]="false"
              [disableFullscreen]="true"
              [documentLoad]="loadAttachmentRef"
              [useViewerOverride]="2"
              [isReadOnly]="'true'"
          ></ap-enhanced-document-viewer>
      </div>
        <div class="modal-footer">
          <button class="btn btn-light btn-flush-right" (click)="close()" translate>Close</button>
        </div>
      </div>
    </div>
  </div>
